import React, { useContext, useMemo, useState } from "react";
import "./Navbar.css";

import SideBar from "../Sidebar/Sidebar";

import BrandLogo from "../../assets/img/OMEX_black.png";
import ImagemUsuario from "../../assets/img/default_user.png";

import { useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import {
  FiBriefcase,
  FiChevronDown,
  FiLogOut,
  FiMenu,
  FiShield,
  FiUser,
} from "react-icons/fi";

import {
  removerDadosUsuario,
  removerDadosUsuario2,
  obterDadosUsuario2,
  apagarPerfilUsuario,
  apagarTipoUsuario,
  obterPerfilUsuario,
  obterServiçosFinanceiros,
} from "../../services/cookies";
import { ServicoFinanceiroClienteContext, usuarioServicoFinanceiroContextType, usuarioServicoFinanceiroTipo } from "../../context/servicoFinanceiroCliente";
import { NotificationBell } from "./NotificationBell";

const getProfileLabel = (perfil: string | null) => {
  if (perfil === "Administrador") return "Gestão";
  if (perfil === "Funcionario") return "Operações";
  if (perfil === "UsuarioCustodia") return "Custódia";
  if (perfil === "UsuarioAssessoria") return "Assessoria";

  return "Omex";
};

const getAccountLabel = (email: string | null) => {
  if (!email) return "Conta Omex";

  return email.split("@")[0].replace(/[._-]+/g, " ");
};

const Navbar = () => {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);

  const dadosUsuario = obterDadosUsuario2();
  const perfil = obterPerfilUsuario();
  const fotoPerfil = dadosUsuario.urlAvatar;
  const srcFotoPerfil = fotoPerfil === "null" || !fotoPerfil ? ImagemUsuario : fotoPerfil;
  const accountLabel = getAccountLabel(dadosUsuario.email);
  const profileLabel = getProfileLabel(perfil);
  const isCliente = perfil === "UsuarioAssessoria" || perfil === "UsuarioCustodia";

  const servicosFinanceiro: usuarioServicoFinanceiroTipo[] = useMemo(
    () => obterServiçosFinanceiros() || [],
    []
  );

  const { atualizarServicoFinanceiro, usuarioServicoFinanceiro } = useContext<usuarioServicoFinanceiroContextType>(ServicoFinanceiroClienteContext);
  const contextoAtual = usuarioServicoFinanceiro?.servicoFinanceiro || profileLabel;

  const navigate = useNavigate();

  const logout = () => {
    removerDadosUsuario();
    removerDadosUsuario2();
    apagarPerfilUsuario()
    apagarTipoUsuario()
    navigate("/");
  };

  return (
    <>
      <header className="omex-navbar">
        <div className="omex-navbar-left">
          <button
            className="omex-navbar-menu-button"
            type="button"
            aria-label="Abrir menu"
            aria-expanded={sidebar}
            onClick={showSidebar}
          >
            <FiMenu />
          </button>

          <button
            className="omex-navbar-brand"
            type="button"
            onClick={() => navigate("/home")}
            aria-label="Ir para a Home"
          >
            <img src={BrandLogo} alt="Omex Capital" />
          </button>
        </div>

        <div className="omex-navbar-center" aria-label="Contexto financeiro">
          {servicosFinanceiro.length === 0 && (
            <div className="omex-navbar-context">
              <span className="omex-navbar-context-icon">
                <FiBriefcase aria-hidden="true" />
              </span>
              <div>
                <small>Ambiente</small>
                <strong>{contextoAtual}</strong>
              </div>
            </div>
          )}

          {servicosFinanceiro.length > 0 && (
            <div className="omex-navbar-services" aria-label="Selecionar serviço financeiro">
              {servicosFinanceiro.map((item) => {
                const isActive = item.idServicoFinanceiro === usuarioServicoFinanceiro.idServicoFinanceiro;

                return (
                  <button
                    key={`${item.id}-${item.idServicoFinanceiro}`}
                    className={`omex-navbar-service ${isActive ? "active" : ""}`}
                    type="button"
                    aria-pressed={isActive}
                    onClick={() => atualizarServicoFinanceiro(item)}
                  >
                    {item.servicoFinanceiro}
                  </button>
                );
              })}
            </div>
          )}
        </div>

        <div className="omex-navbar-right">
          {isCliente && <NotificationBell />}

          <div className="omex-navbar-security">
            <FiShield aria-hidden="true" />
            <span>Seguro</span>
          </div>

          <Dropdown className="omex-navbar-account" align="end">
            <Dropdown.Toggle
              as="button"
              type="button"
              id="omex-navbar-account-toggle"
              className="omex-navbar-account-toggle"
              aria-label="Abrir opções do usuário"
            >
              <img
                alt="Foto do usuário"
                src={srcFotoPerfil}
                className="omex-navbar-avatar"
              />
              <span className="omex-navbar-account-copy">
                <small>{profileLabel}</small>
                <strong>{accountLabel}</strong>
              </span>
              <FiChevronDown aria-hidden="true" />
            </Dropdown.Toggle>

            <Dropdown.Menu className="omex-navbar-account-menu">
              <div className="omex-navbar-account-summary">
                <img alt="Foto do usuário" src={srcFotoPerfil} />
                <div>
                  <strong>{accountLabel}</strong>
                  <span>{dadosUsuario.email || "Sessão ativa"}</span>
                </div>
              </div>

              <Dropdown.Item onClick={() => navigate("/dados-cadastrais")}>
                <FiUser aria-hidden="true" />
                Dados cadastrais
              </Dropdown.Item>

              <Dropdown.Item onClick={logout}>
                <FiLogOut aria-hidden="true" />
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </header>
      <SideBar sidebar={sidebar} showSidebar={showSidebar} />
    </>
  );
};

export default Navbar;
